import React, { useState, useContext, useEffect } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";

import { ClipLoading } from "../../../components/Loadings";
import { Context } from "../../../Utility/ContextManager";
import { userInfoValidations } from "../../../Utility/Validations";

export default function UserInfoForm({ showUserInfoModal, handleClose, UpdateOrCreateDwollaAccount, loading }) {
  const { user } = useContext(Context);

  const [userInfo, setUserInfo] = useState({});
  const [userInfoErrors, setUserInfoErrors] = useState({});

  useEffect(() => {
    setUserInfo({
      firstName: user?.first_name,
      lastName: user?.last_name,
      email: user?.email,
    });
  }, [showUserInfoModal]);

  const onChange = (text, name) => {
    setUserInfo({
      ...userInfo,
      [name]: text,
    });
  };

  const saveInfo = async () => {
    const resetError = userInfoValidations(userInfo);
    setUserInfoErrors(resetError);
    if (Object.keys(resetError).length === 0) {
      UpdateOrCreateDwollaAccount(userInfo);
    }
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      className="modal-style-1"
      centered
      show={showUserInfoModal}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Please {user?.status === "REVERIFICATION" ? "re-submit" : "enter"} below details before adding bank account
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <div className={"mb-3 " + (userInfoErrors?.firstName && "error")}>
              <label htmlFor="Old Password" className="form-label">
                First Name
              </label>
              <input
                disabled={loading}
                className="form-control"
                id="oldPassword"
                placeholder="Enter First Name"
                defaultValue={userInfo?.firstName}
                onChange={(e) => {
                  onChange(e.target.value, "firstName");
                }}
              />
              {userInfoErrors?.firstName && <p className="passwordError">{userInfoErrors?.firstName}</p>}
            </div>
          </Col>
          <Col md={6}>
            <div className={"mb-3 " + (userInfoErrors?.lastName && "error")}>
              <label htmlFor="Old Password" className="form-label">
                Last Name
              </label>
              <input
                disabled={loading}
                defaultValue={userInfo?.lastName}
                className="form-control"
                id="oldPassword"
                placeholder="Enter Last Name"
                onChange={(e) => {
                  onChange(e.target.value, "lastName");
                }}
              />
              {userInfoErrors?.lastName && <p className="passwordError">{userInfoErrors?.lastName}</p>}
            </div>
          </Col>
          <Col md={6}>
            <div className={"mb-3 " + (userInfoErrors?.email && "error")}>
              <label htmlFor="Old Password" className="form-label">
                Email
              </label>
              <input
                disabled={loading}
                className="form-control"
                id="oldPassword"
                placeholder="Enter Email"
                defaultValue={userInfo?.email}
                onChange={(e) => {
                  onChange(e.target.value, "email");
                }}
              />
              {userInfoErrors?.email && <p className="passwordError">{userInfoErrors?.email}</p>}
            </div>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        {user?.status === "REVERIFICATION" && (
          <p className="text-danger" style={{ fontSize: "12px" }}>
            Dwolla was unable to verify your information, please re-submit correct information. You can only re-submit
            your information once and if it's not correct, your account will be suspended and you won't be able to make
            online payments.
          </p>
        )}
        {!loading ? (
          <Button variant="primary" onClick={saveInfo}>
            Save
          </Button>
        ) : (
          <ClipLoading loading={loading} />
        )}
      </Modal.Footer>
    </Modal>
  );
}
